<template>
    <div v-if="visible" div class="subtitle-overlay">
        <div class="subtitle-toolbar">
            <span class="subtitle-title">자막</span>

            <span class="subtitle-count">
                {{ subtitleFiles.length }}
            </span>

            <!--<button class="close-btn"
                    @click="$emit('close')">
                ✕
            </button>-->
        </div>

        <div class="subtitle-sync">
            <button @click="adjustSync(-1000)">-1.0</button>
            <button @click="adjustSync(-500)">-0.5</button>
            <button @click="adjustSync(-100)">-0.1</button>

            <span class="sync-value">
                {{ (sync / 1000).toFixed(1) }}s
            </span>

            <button @click="adjustSync(100)">+0.1</button>
            <button @click="adjustSync(500)">+0.5</button>
            <button @click="adjustSync(1000)">+1.0</button>

            <button class="reset"
                    @click="resetSync">
                Reset
            </button>
        </div>

        <div class="subtitle-body">
            <div v-for="item in subtitleFiles"
                 :key="item.name"
                 class="subtitle-item"
                 :class="{ active: item.name === selectedSubtitle }"
                 @click="selectSubtitle(item)">

                <MarqueeText class="subtitle-name"
                             :text="item.name" />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed, ref } from "vue";
    import { useStore } from "vuex";  
    import MarqueeText from "@/utils/MarqueeText.vue";

    const store = useStore();

    const subtitleFiles = computed(() => {

        return (
            store.state.files.fileArray || []
        ).filter(item => {

            if (!item.isFile)
                return false;


            const ext =
                item.name
                    ?.split(".")
                    .pop()
                    ?.toLowerCase();


            return [
                "vtt",
                "srt",
                "smi"
            ].includes(ext);

        });

    });


    const selectedSubtitle = computed(
        () =>
            store.state.subtitle.subtitleName
    );


    const sync = computed(
        () =>
            store.state.subtitle.sync
    );


    const emit = defineEmits([
        "adjust-sync",
        "reset-sync",
        "select-subtitle"
    ])

    const visible = ref(false);

    function toggle() {
        visible.value = !visible.value;
    }

    defineExpose({
        toggle
    });

    function adjustSync(ms) {

        store.dispatch(
            "subtitle/adjustSync",
            ms
        );

    }


    function resetSync() {

        store.dispatch(
            "subtitle/resetSync"
        );

    }


    function selectSubtitle(item) {
        store.dispatch(
            "subtitle/selectSubtitle",
            item
        );

    }
</script>

<style scoped>
    .subtitle-overlay {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 310px;
        max-height: calc(100% - 40px);
        display: flex;
        flex-direction: column;
        background: rgba(0,0,0,.75);
        border-radius: 8px;
        z-index: 1000;
    }

    .subtitle-toolbar {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px;
        flex-shrink: 0;
    }

    .subtitle-title {
        color: white;
        font-weight: 600;
    }

    .subtitle-count {
        margin-left: auto;
        color: #bbb;
        font-size: 13px;
    }

    .subtitle-body {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        padding: 4px;
    }

    .subtitle-item {
        display: flex;
        align-items: center;
        padding: 8px 10px;
        margin-bottom: 4px;
        border-radius: 6px;
        cursor: pointer;
        color: #ddd;
        transition: .15s;
    }

    .subtitle-name {
        flex: 1;
        min-width: 0; /* 중요 */
    }

        .subtitle-item:hover {
            background: rgba(255,255,255,.08);
        }

        .subtitle-item.active {
            background: rgba(25,118,210,.8);
            color: white;
        }


    .marquee-container {
        flex: 1;
    }

    .subtitle-sync {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px 8px;
        border-top: 1px solid rgba(255,255,255,.08);
        border-bottom: 1px solid rgba(255,255,255,.08);
        background: rgba(255,255,255,.04);
    }

        .subtitle-sync button {
            background: rgba(30,30,30,.8);
            color: white;
            border: 1px solid rgba(255,255,255,.2);
            font-size: 11px;
            padding: 2px 6px;
            cursor: pointer;
        }

            .subtitle-sync button:hover {
                background: rgba(60,60,60,.9);
            }

    .sync-value{
        color: white;
        font-size: 11px;
    }

    .close-btn {
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 6px;
        background: rgba(255,255,255,.08);
        color: white;
        cursor: pointer;
    }
        .close-btn:hover {
            background: rgba(60,60,60,.9);
        }

    @media (max-width: 768px) {
        .subtitle-overlay {
            transform: scale(.82);
            transform-origin: top left;
        }
    }
</style>